import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import CaretDownIcon from '@/assets/icons/ic-caret-down.svg';
import CaretUpIcon from '@/assets/icons/ic-caret-up.svg';
import OpenInNewIcon from '@/assets/icons/ic-open-in-new.svg';
import PaperIcon from '@/assets/icons/ic-paper.svg';
import SlidesDownloadIcon from '@/assets/icons/ic-slides-download.svg';

import { DownloadButton } from '@/components/ui/shared/buttons/DownloadButton/DownloadButton';

interface IMultipleResourceDownloadProps {
  pdfUrl: string;
  slidesUrl: string;
  paperLink: string;
}

export const MultipleResourceDownload: FC<IMultipleResourceDownloadProps> = ({ pdfUrl, slidesUrl, paperLink }) => {
  const { t } = useTranslation();

  return (
    <Menu>
      {({ isOpen }) => (
        <Fragment>
          <MenuButton
            as={Button}
            variant="outline"
            size="sm"
            minW="max-content"
            maxW="max-content"
            _active={{ bg: 'violet.500', color: 'white' }}
            rightIcon={isOpen ? <CaretUpIcon /> : <CaretDownIcon />}
          >
            {t('eventResource.downloadsTitle')}
          </MenuButton>

          <MenuList>
            <MenuItem py={2}>
              <DownloadButton
                url={slidesUrl}
                download="slides"
                variant="unstyled"
                w="full"
                borderRadius={0}
                rightIcon={<SlidesDownloadIcon />}
              >
                {t('eventResource.downloadSlides')}
              </DownloadButton>
            </MenuItem>
            {pdfUrl ? (
              <MenuItem py={2}>
                <DownloadButton
                  url={pdfUrl}
                  download="paper"
                  variant="unstyled"
                  w="full"
                  borderRadius={0}
                  rightIcon={<PaperIcon />}
                >
                  {t('eventResource.downloadPaper')}
                </DownloadButton>
              </MenuItem>
            ) : null}

            {paperLink ? (
              <MenuItem py={2}>
                <DownloadButton
                  url={paperLink}
                  variant="unstyled"
                  w="full"
                  borderRadius={0}
                  rightIcon={<OpenInNewIcon />}
                >
                  {t('eventResource.viewPaper')}
                </DownloadButton>
              </MenuItem>
            ) : null}
          </MenuList>
        </Fragment>
      )}
    </Menu>
  );
};
